PegasusTemplate.LoadingRoute = Ember.Route.extend({
  setupController: function(){
    this.controllerFor('modal').set('presenter', null);
    PegasusTemplate.set('loaded', false);
    PegasusTemplate.set('status', 'loading');
    //this.send('loadTemplate');
  },
  actions: {

  }
});
